<i18n src="../../locales/lang.json"></i18n>
<template>
  <div>
    <modal-default v-bind:title="$t('invite_user')" v-bind:buttontext="$t('send_invitations')" ref="thisModal" v-bind:onsave="doInvite" size="modal-xs mx-4 mx-md-auto">
      <div style="max-height:calc(100vh - 270px);overflow-y:auto">
        <div class="container-fluid pb-3">
          <div class="row mt-3 mb-3">
            <div class="col-12 custom-form-label">
              <button type="button" @click="copy" class="btn btn-light col-10"><i class="icon-link mt-1 pull-left"></i>{{$t('copy_url')}}</button>
              <qr-invite-button ref="qrbutton" class="ml-2"></qr-invite-button>
            </div>
            <div class="col-12 mt-1 text-center custom-form-label" v-show="confirmCopy == true">
              <label class="custom-form-label">{{$t('copied_to_clipboard')}}</label>
            </div>
          </div>
          <div v-for="(email,index) in emails" class="row mt-1">
            <div class="col-11">
              <input v-model="email.email" v-bind:placeholder="$t('enter_email')" type="email" class="form-control" name="email" v-bind:id="'txt_email_' +  getId()">
            </div>
            <div class="col-1 px-0"><a href="#" @click="deleteEmail(index)" style="color: inherit;;"><i style="font-size: 16px; color: inherit; margin-top: 10px" class="fa fa-trash-o"></i></a></div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <a href="#" @click="addEmailControl" style="color: inherit">+ {{$t('add_another')}}</a>
            </div>
          </div>
        </div>
      </div>
    </modal-default>
  </div>
</template>

<script>
  import ModalDefault from "../modals/modal-default.vue";
  export default {
    name: "team-registration-invite",
    components: {
      ModalDefault,
    },
    props: {
    },
    data() {
      return {
        teamId: -1,
        emails: [],
        index: 0,
        link: '',
        siteUniqueId: '',
        confirmCopy: false,
        qrlink: null
      };
    },
    methods: {
      copy_old() {
        this.$refs.clone.focus();
        document.execCommand('copy');
      },

      copy() {
        const el = document.createElement('textarea');
        el.value = this.link;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }
        this.confirmCopy = true;
      },
      addEmailControl() {
        this.emails.push({ id: this.index, email: '' });
        this.index++;        
        Vue.set(this, "emails", this.emails)
        this.$forceUpdate();
      },
      deleteEmail(index) {
        this.emails.splice(index, 1);
        console.log(this.emails);
        Vue.set(this, "emails", this.emails);
        this.$forceUpdate();
      },
      getId() {
        return this._uid;
      },
      
      getSiteUniqueId() {
        try {
          var url = '/api/Sites/v1/detail';
          this.$http.get(url).then(async response => {
            var data = response.data;    
            this.siteUniqueId = data.UniqueId;            
            this.$forceUpdate();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },

      open(teamId) {
        this.emails = [];
        this.index = 0;
        this.$refs.thisModal.open();
        this.emails.push({ id: this.index, email: '' });
        Vue.set(this, "emails", this.emails)
        this.index++;
        this.teamId = teamId;

        this.$refs.qrbutton.lang = this.$store.getLocale()
        if (this.teamId > 0) {
          this.$refs.qrbutton.teamid = '' + this.teamId;
          this.link = window.location.origin + '/link/' + this.siteUniqueId + '/register/' + this.teamId + '?lang=' + this.$store.getLocale();
        } else {
          this.$refs.qrbutton.teamid = null;
          this.link = window.location.origin + '/link/' + this.siteUniqueId + '/register' + '?lang=' + this.$store.getLocale();
        }
        this.$forceUpdate();        
      },

      async doInvite() {
        var mails = [];
        this.emails.forEach((item, index) => {
          mails.push(item.email);
        });        
        var request = {
          emails: mails,
          link: this.link,
        };
        
        ///api/Procedure/ScheduleProcedure
        try {
          var response = this.$http.post(
            '/api/team/SendInvitation',
            request
          ).then(async response => {
            this.$refs.thisModal.close();
          });
        } catch (err) {
          alert(err);
        }

      },

    },
    computed: {

    },
    watch: {

    },
    mounted() {
      this.getSiteUniqueId();
    },
    created() {

    },
  };

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/team/team-registration-invite.vue